export interface SearchableDirectoryItem {
  label: string;
  aliases: string[];
  context?: string;
}

function normalize(value: string): string {
  return value
    .toLocaleLowerCase('en-IN')
    .normalize('NFKD')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

export function matchesDirectoryQuery(
  item: SearchableDirectoryItem,
  query: string,
): boolean {
  const normalizedQuery = normalize(query);

  if (!normalizedQuery) {
    return true;
  }

  const haystack = normalize(
    [item.label, ...item.aliases, item.context ?? ''].join(' '),
  );

  return normalizedQuery
    .split(' ')
    .filter(Boolean)
    .every((token) => haystack.includes(token));
}
